import React, { memo } from 'react';

const Searchbar = ({ placeholder, search, width = '250px', searchValue }) => {
  return (
    <div className={'mb-2 pt-2 has-search'}>
      <span className={'fas fa-search form-control-feedback'}></span>
      <input
        type="text"
        className="form-control adjust-fs text-muted"
        placeholder={placeholder}
        value={searchValue}
        style={{ paddingLeft: '35px', width }}
        onChange={search}
      />
    </div>
  );
};

export default memo(Searchbar);
